var map = {
	"./1.jpg": 64,
	"./10.jpg": 65,
	"./11.jpg": 66,
	"./117.jpg": 67,
	"./12.jpg": 68,
	"./13.jpg": 69,
	"./14.jpg": 70,
	"./15.jpg": 71,
	"./16.jpg": 72,
	"./17.jpg": 73,
	"./18.jpg": 74,
	"./19.jpg": 75,
	"./2.jpg": 76,
	"./21.jpg": 77,
	"./22.jpg": 78,
	"./3.jpg": 79,
	"./4.jpg": 80,
	"./5.jpg": 81,
	"./6.jpg": 82,
	"./7.jpg": 83,
	"./9.jpg": 84,
	"./ambrosia.jpg": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;